/**
 * Scratch Card Popup: weighted prize pick, canvas scratch-to-reveal, email claim, Klaviyo sync.
 */
(function () {
  // Klaviyo Client API requires a revision header — bump this if Klaviyo deprecates it.
  var KLAVIYO_REVISION = '2024-10-15';

  function shadeColor(hex, percent) {
    var f = parseInt(hex.replace('#', ''), 16);
    var t = percent < 0 ? 0 : 255;
    var p = Math.abs(percent) / 100;
    var R = f >> 16;
    var G = (f >> 8) & 0x00ff;
    var B = f & 0x0000ff;
    return (
      '#' +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  }

  function drawSpacedText(ctx, text, centerX, centerY, spacing) {
    var chars = text.split('');
    var widths = chars.map(function (c) {
      return ctx.measureText(c).width;
    });
    var total = widths.reduce(function (a, b) { return a + b; }, 0) + spacing * (chars.length - 1);
    var x = centerX - total / 2;
    ctx.textAlign = 'left';
    for (var i = 0; i < chars.length; i++) {
      ctx.fillText(chars[i], x, centerY);
      x += widths[i] + spacing;
    }
    ctx.textAlign = 'center';
  }

  function pickPrize(prizes) {
    var total = 0;
    for (var i = 0; i < prizes.length; i++) {
      total += prizes[i].weight > 0 ? prizes[i].weight : 0;
    }
    if (!total) return prizes[0];
    var r = Math.random() * total;
    for (var j = 0; j < prizes.length; j++) {
      r -= prizes[j].weight > 0 ? prizes[j].weight : 0;
      if (r <= 0) return prizes[j];
    }
    return prizes[prizes.length - 1];
  }

  function initCard(root) {
    var dataEl = root.querySelector('[data-scratch-prizes]');
    var card = root.querySelector('[data-scratch-card]');
    var canvas = root.querySelector('[data-scratch-canvas]');
    var labelEl = root.querySelector('[data-prize-label]');
    var subEl = root.querySelector('[data-prize-sub]');
    var claimBlock = root.querySelector('[data-claim-block]');
    var claimForm = root.querySelector('[data-claim-form]');
    var claimEmail = root.querySelector('[data-claim-email]');
    var claimConsent = root.querySelector('[data-claim-consent]');
    var claimError = root.querySelector('[data-claim-error]');
    var rewardBlock = root.querySelector('[data-reward-block]');
    var rewardCopy = root.querySelector('[data-reward-copy]');
    var codeBox = root.querySelector('[data-code-box]');
    var codeText = root.querySelector('[data-code-text]');
    var copyBtn = root.querySelector('[data-copy-code]');
    var shopLink = root.querySelector('[data-shop-link]');

    if (!dataEl || !canvas || !card) return;

    var prizes;
    try {
      prizes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!prizes || !prizes.length) return;

    var prize = pickPrize(prizes);
    var scratchColor = root.dataset.scratchColor || '#D4AF37';
    var scratchLabel = root.dataset.scratchLabel || 'SCRATCH HERE';

    if (labelEl) labelEl.textContent = prize.label || '';
    if (subEl) subEl.textContent = prize.sub || '';

    var ctx = canvas.getContext('2d');
    var revealed = false;
    var isScratching = false;
    var rafPending = false;

    function drawCover() {
      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        requestAnimationFrame(drawCover);
        return;
      }
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.round(rect.width * dpr));
      canvas.height = Math.max(1, Math.round(rect.height * dpr));
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var w = rect.width;
      var h = rect.height;

      ctx.globalCompositeOperation = 'source-over';

      var foil = ctx.createLinearGradient(0, 0, w, h);
      foil.addColorStop(0, shadeColor(scratchColor, 22));
      foil.addColorStop(0.5, scratchColor);
      foil.addColorStop(1, shadeColor(scratchColor, -22));
      ctx.fillStyle = foil;
      ctx.fillRect(0, 0, w, h);

      var sheen = ctx.createLinearGradient(0, 0, w, h);
      sheen.addColorStop(0.32, 'rgba(255,255,255,0)');
      sheen.addColorStop(0.48, 'rgba(255,255,255,0.18)');
      sheen.addColorStop(0.64, 'rgba(255,255,255,0)');
      ctx.fillStyle = sheen;
      ctx.fillRect(0, 0, w, h);

      ctx.fillStyle = 'rgba(255,255,255,0.92)';
      ctx.font = '700 ' + Math.round(w * 0.085) + 'px Arial, Helvetica, sans-serif';
      ctx.textBaseline = 'middle';
      drawSpacedText(ctx, scratchLabel, w / 2, h / 2, w * 0.012);
    }

    function pointFromEvent(evt) {
      var rect = canvas.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top,
      };
    }

    function scratchAt(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 20, 0, Math.PI * 2);
      ctx.fill();
    }

    function scratchedRatio() {
      var w = canvas.width;
      var h = canvas.height;
      if (!w || !h) return 0;
      var data = ctx.getImageData(0, 0, w, h).data;
      var transparent = 0;
      var samples = 0;
      for (var i = 3; i < data.length; i += 4 * 8) {
        samples++;
        if (data[i] < 80) transparent++;
      }
      return samples ? transparent / samples : 0;
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      canvas.classList.add('is-revealed');
      if (claimBlock) claimBlock.hidden = false;
      root.dispatchEvent(new CustomEvent('scratch-popup:revealed', { detail: { prize: prize }, bubbles: true }));
    }

    function checkReveal() {
      if (revealed) return;
      if (scratchedRatio() >= 0.5) reveal();
    }

    function handleMove(evt) {
      if (!isScratching) return;
      var p = pointFromEvent(evt);
      scratchAt(p.x, p.y);
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          checkReveal();
        });
      }
    }

    canvas.addEventListener('pointerdown', function (evt) {
      if (revealed) return;
      isScratching = true;
      canvas.setPointerCapture(evt.pointerId);
      var p = pointFromEvent(evt);
      scratchAt(p.x, p.y);
    });
    canvas.addEventListener('pointermove', handleMove);
    canvas.addEventListener('pointerup', function () {
      isScratching = false;
      checkReveal();
    });
    canvas.addEventListener('pointercancel', function () {
      isScratching = false;
    });

    drawCover();
    window.addEventListener('resize', function () {
      if (!revealed) drawCover();
    });

    function markClaimed() {
      var modal = root.closest('modal-dialog');
      if (modal && modal.id) {
        try {
          window.localStorage.setItem(modal.id, JSON.stringify(new Date()));
        } catch (e) {}
      }
    }

    function syncKlaviyo(email) {
      var companyId = root.dataset.klaviyoCompanyId;
      var listId = root.dataset.klaviyoListId;
      if (!companyId) return;

      if (listId) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: { 'Scratch Card Prize': prize.label },
                    },
                  },
                },
              },
              relationships: {
                list: { data: { type: 'list', id: listId } },
              },
            },
          }),
        }).catch(function () {});
      }

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { Prize: prize.label, Code: prize.code || '' },
              metric: { data: { type: 'metric', attributes: { name: 'Scratch Card Won' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
            },
          },
        }),
      }).catch(function () {});
    }

    function showReward(email) {
      if (claimBlock) claimBlock.hidden = true;
      if (rewardBlock) rewardBlock.hidden = false;

      if (rewardCopy) {
        var defaultHeading = root.dataset.rewardHeading || '';
        rewardCopy.textContent = prize.code ? defaultHeading : prize.noCodeMessage || defaultHeading;
      }

      if (prize.code) {
        if (codeBox) codeBox.hidden = false;
        if (codeText) codeText.textContent = prize.code;
      } else if (codeBox) {
        codeBox.hidden = true;
      }

      if (shopLink) {
        var link = prize.link || root.dataset.defaultShopLink || '/collections/all';
        shopLink.setAttribute('href', link);
      }

      markClaimed();
      syncKlaviyo(email);
    }

    if (claimForm) {
      claimForm.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var email = (claimEmail && claimEmail.value || '').trim();
        var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!emailValid) {
          if (claimError) {
            claimError.textContent = root.dataset.errorInvalidEmail || 'Please enter a valid email address.';
            claimError.hidden = false;
          }
          return;
        }
        if (claimConsent && claimConsent.hasAttribute('required') && !claimConsent.checked) {
          if (claimError) {
            claimError.textContent = root.dataset.errorConsent || 'Please accept the terms to continue.';
            claimError.hidden = false;
          }
          return;
        }
        if (claimError) claimError.hidden = true;

        showReward(email);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var text = codeText ? codeText.textContent : '';
        if (!text) return;
        var done = function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = root.dataset.copiedLabel || 'Copied!';
          setTimeout(function () {
            copyBtn.textContent = original;
          }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(done);
        } else {
          var helper = document.createElement('textarea');
          helper.value = text;
          document.body.appendChild(helper);
          helper.select();
          try {
            document.execCommand('copy');
          } catch (e) {}
          document.body.removeChild(helper);
          done();
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-scratch-popup]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
